export const FFS_EMAIL_ADDRESS = 'FinancialFlowsSupport@cimpress.com';
export const MAX_INT = 2147483647;
export const DEFAULT_LANGUAGE = 'en';
export const SupportedLanguages = ['en', 'de', 'fr', 'it', 'nl'];
